module.exports = __webpack_public_path__ + "static/media/geschichte-bluete.f3a3d03b.jpg";